import { useState } from 'react';

export default function MotorcycleCard({ motorcycle }) {
  const [imageError, setImageError] = useState(false);

  const conditionColors = {
    'New': '#2ecc71',
    'Used': '#e67e22',
    'Project / Parts Only': '#95a5a6'
  };

  const firstImage = motorcycle.images?.[0];

  return (
    <div style={styles.card}>
      <div style={styles.imageContainer}>
        {firstImage && !imageError ? (
          <img
            src={firstImage}
            alt={motorcycle.title}
            style={styles.image}
            onError={() => setImageError(true)}
          />
        ) : (
          <div style={styles.placeholder}>
            <span style={{ fontSize: 40 }}>🏍️</span>
          </div>
        )}
        <span style={{
          ...styles.conditionBadge,
          background: conditionColors[motorcycle.condition] || '#95a5a6'
        }}>
          {motorcycle.condition}
        </span>
      </div>
      <div style={styles.content}>
        <span style={styles.yearMake}>
          {motorcycle.year} {motorcycle.make}
        </span>
        <h3 style={styles.model}>{motorcycle.model}</h3>
        {motorcycle.displacement && (
          <span style={styles.spec}>{motorcycle.displacement}cc</span>
        )}
        <p style={styles.price}>${motorcycle.price?.toLocaleString('en-CA')}</p>
        {motorcycle.mileage != null && (
          <span style={styles.mileage}>{motorcycle.mileage.toLocaleString()} km</span>
        )}
      </div>
    </div>
  );
}

const styles = {
  card: {
    background: '#fff',
    borderRadius: 12,
    border: '1px solid #e2e8f0',
    overflow: 'hidden',
    transition: 'transform .15s, box-shadow .15s',
    cursor: 'pointer'
  },
  imageContainer: {
    position: 'relative',
    height: 180,
    background: '#f8fafc'
  },
  image: {
    width: '100%',
    height: '100%',
    objectFit: 'cover'
  },
  placeholder: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#f1f5f9'
  },
  conditionBadge: {
    position: 'absolute',
    top: 8,
    right: 8,
    fontSize: 11,
    padding: '2px 8px',
    borderRadius: 4,
    color: '#fff',
    fontWeight: 600
  },
  content: {
    padding: 12
  },
  yearMake: {
    fontSize: 12,
    color: '#64748b'
  },
  model: {
    fontSize: 16,
    fontWeight: 600,
    color: '#1e293b',
    margin: '4px 0',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },
  spec: {
    fontSize: 12,
    color: '#94a3b8',
    marginRight: 8
  },
  price: {
    fontSize: 18,
    fontWeight: 700,
    color: '#4f46e5',
    margin: '8px 0'
  },
  mileage: {
    fontSize: 12,
    color: '#64748b'
  }
};